import React from 'react'
import { Link } from 'react-router-dom'
import SearchBar from 'src/Components/HelpCenter/SearchBar'
import DashboardNavIcon from '../../Common/Icon/DashboardNavIcon'
import GovernanceNavIcon from '../../Common/Icon/GovernanceNavIcon'
import RiskNavIcon from '../../Common/Icon/RiskNavIcon'
import ComplainceNavIcon from '../../Common/Icon/ComplainceNavIcon'
import SettingsNavIcon from '../../Common/Icon/SettingsNavIcon'
import Tools from '../../Common/Icon/ToolsIcon.svg'
import { Divider } from '@mui/material'

export const categories = [
    { name: 'Dashboard', path: '/GRC/help-center/dashboard', icon: <DashboardNavIcon isActive={true} width={' 30% '}/> },
    { name: 'Governance', path: '/GRC/help-center/governance', icon: <GovernanceNavIcon isActive={true} width={' 30% '}/> },
    { name: 'Risk', path: '/GRC/help-center/risk', icon: <RiskNavIcon isActive={true} width={' 30% '}/> },
    { name: 'Compliance', path: '/GRC/help-center/compliance', icon: <ComplainceNavIcon isActive={true} width={' 30% '}/> },
    { name: 'Calendar', path: '/GRC/help-center/calendar', icon: <img src={'/Assets/CalendarHelp.svg'} alt="Calendar" className="w-12"/> },
    { name: 'Tools', path: '/GRC/help-center/tools', icon: <img src={Tools} alt="Tools" className="w-12"/> },
    { name: 'Settings', path: '/GRC/help-center/settings', icon: <SettingsNavIcon isActive={true} width={' 30% '}/> }
]

const HelpCenterHome = () => {
    return (
        <div className='text-primary flex flex-col items-center w-full h-full bg-[#fff] p-10'>
            <img src={'/Assets/CtdFullLogo.svg'} alt="Assure Logo" className="w-[300px] mb-8" />
            <div className='flex flex-row gap-5 items-center justify-center w-full mb-8'>
                <Divider sx={{ width: '40%' }}/>
                <h2 className="text-center text-2xl font-bold my-4 w-fit text-nowrap">How can we help you?</h2>
                <Divider sx={{ width: '40%' }}/>
            </div>
            <SearchBar />
            <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-14 p-4 w-2/3 justify-between">
                {categories.map((cat) => {
                    if (cat.name === 'Tools') return null

                    return (
                        <Link
                            key={cat.name}
                            to={cat.path}
                            className="border border-[#b2d9d8] p-4 rounded-md text-center hover:bg-primary-foreground hover:shadow-md hover:border-[#00a2a1] transition-all flex flex-col items-center justify-center gap-2"
                        >
                            <span className="flex justify-center">{cat.icon}</span>
                            <p className='text-lg font-semibold'>{cat.name}</p>
                        </Link>
                    )
                })}
            </div>
        </div>
    )
}

export default HelpCenterHome
